<template>
  <div class="text-center">
    <h5>Signing in...</h5>
    <img src="/assets/loading.gif" />
    <div id="idToken"></div>
    <div id="access_token"></div>
    <div id="id_token"></div>
  </div>
</template>

<script>
import authMixin from "@/mixins/auth-mixin.js";

export default {
  name: "Accept",
  mixins: [authMixin],
  data() {
    return {
      error: "",
      attemptsRemaining: 6,
      interval: null,
    };
  },
  mounted() {
    if (window.location.hash) {
      this.$authService.msal
        .handleRedirectPromise(window.location.hash)
        .then((response) => {
          if (response !== null) {
            this.setupAuth(response);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      this.interval = setInterval(() => this.update(), 5 * 1000);
      this.update();
    }
  },
  methods: {
    update() {
      if ((this.authenticated && this.user != null) || this.setup === false) {
        this.handleRedirect();
      } else if (this.attemptsRemaining === 0) {
        this.attemptsRemaining--;
        // //Case 1: The MSAL authentication never worked.
        // if (this.authenticated) {
        //   this.$msal
        //   .acquireToken({ scopes: ["user.read"]})
        //   .then(response => {
        //     if (response) {
        //       clearInterval(this.interval);
        //       this.$auth.msalAuth(this.$msal, this.$auth, response);
        //     } else {
        //       //this.defaultRedirect();
        //       clearInterval(this.interval);
        //       this.$store.dispatch('setReturnUrl', window.location.pathname);
        //       this.$store.dispatch('setAuthError', "Sorry, but your authentication expired. Please make sure third-party cookies are enabled.");

        //       this.$auth.clearSession().then(() => {
        //         this.$msal.signOut();
        //       });
        //     }
        //   })
        //   .catch(err => {
        //     clearInterval(this.interval);
        //     this.$store.dispatch('setReturnUrl', window.location.pathname);
        //     this.$store.dispatch('setAuthError', "Sorry, but your authentication expired. Please make sure third-party cookies are enabled.");

        //     this.$auth.clearSession().then(() => {
        //       this.$msal.signOut();
        //     });
        //   });
        // } else {
        //   this.defaultRedirect();
        // }
      } else {
        this.attemptsRemaining--;
      }
    },
    redirectOut() {
      if (!this.authenticated) {
        this.$router.push({
          name: "Login",
          query: { error: "Authentication timed out" },
        });
      }
    },
    handleRedirect() {
      clearInterval(this.interval);
      let url = this.$store.getters.getReturnUrl;
      if (url) {
        this.$store.dispatch("setReturnUrl", "");
        this.defaultRedirect(url);
      } else {
        this.defaultRedirect();
      }
    },
  },
  computed: {
    user() {
      return this.accountUser;
    },
    // authError() {
    //   return this.$store.getters.getAuthError;
    // },
    setup() {
      return this.user == null ? null : this.user.setup === true;
    },
  },
  watch: {
    authenticated(val) {
      if (val === true && this.user != null) {
        this.handleRedirect();
      }
    },
    user(val) {
      if (val != null && this.authenticated) {
        this.handleRedirect();
      }
    },
    setup(val) {
      if (val === false) {
        this.handleRedirect();
      }
    },
  },
};
</script>